<div class="row d-flex justify-content-between">
    <div class="col-md-7 divSearch">
      <app-search [list]="AllGalleriesForWorkshop" [OriginalList]="OriginalGalleries" [column]="'name'"
        (newItemEvent)="GetFilteredList($event)"></app-search>
    </div>
    <div class="col-md-4 divCreate">
      <a [routerLink]="['/dashboard/create-sales-representative']" class="btnCreate btn-icon-group">
        <i-tabler name="plus" class="icon-15 btn-icon"></i-tabler>
        {{ 'addNewSalesRepresentative' | translate}}
      </a>
    </div>
  </div>

  <div class="count" *ngIf="AllGalleriesForWorkshop.length!=0">{{'Results'| translate}}: {{AllGalleriesForWorkshop.length}}</div>
  <div class="row" *ngIf="AllGalleriesForWorkshop">
      <div *ngIf="!AllGalleriesForWorkshop;then NoGalleriesForWorkshop else GalleriesForWorkshop"></div>

      <ng-template #NoGalleriesForWorkshop>
        <div class="col-md-12">
          <p> {{ 'NoDataFound' | translate }}</p>
        </div>
      </ng-template>

      <ng-template #GalleriesForWorkshop>

        <div class="col-lg-4 col-sm-4 m-b-15" *ngFor="let gallery of AllGalleriesForWorkshop">
          <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
            <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
              <mat-card-title class="mat-mdc-card-title text-white">{{ gallery.name| subString:20 }}</mat-card-title>
              <div class="d-flex divIcons">
                <i-tabler name="edit" class="icon-20 d-flex clickIcon" (click)="EditGallery(gallery.id)"></i-tabler>
                <i-tabler name="eye" class="icon-20 d-flex clickIcon" (click)="ViewGallery(gallery.id)"></i-tabler>
              </div>
            </mat-card-header>
            <mat-card-content class="mat-mdc-card-content text-center">
              <div class="row">
                <div class="col-md-9">
                  <table class="table w-100">
                    <tr>
                      <td>
                        <i-tabler name="map-pins" class="icon-15 d-flex"></i-tabler>
                      </td>
                      <td><span class="span-title">{{ 'Address' | translate }} </span></td>
                      <td><span>{{ gallery.agentAddress| subString:8 }}</span></td>
                    </tr>
                    <tr>
                      <td>
                        <i-tabler name="Phone" class="icon-15 d-flex"></i-tabler>
                      </td>
                      <td><span class="span-title">{{ 'Phone' | translate }}</span></td>
                      <td><span> {{ gallery.agentPhone }}</span></td>
                    </tr>
                    <tr>
                      <td>
                        <i-tabler name="mail" class="icon-15 d-flex"></i-tabler>
                      </td>
                      <td><span class="span-title">{{ 'Email' | translate }}</span></td>
                      <td><span> {{ gallery.email }}</span></td>
                    </tr>
                  </table>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-template>
    </div>
